import React, { useContext } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { MobileContext } from "components/common";
import ManageCardDesktop from "./ManageCardDesktop";
import ManageCardMobile from "./ManageCardMobile";

const ManageCard = ({
  user,
  isRiskLocked,
  resetSuccess = () => {},
  SettingsButton,
  SettingsInputContainer,
  roles,
}) => {
  const { isMobile } = useContext(MobileContext);
  const Component = isMobile ? ManageCardMobile : ManageCardDesktop;
  return (
    <Component
      user={user}
      roles={roles}
      isRiskLocked={isRiskLocked}
      resetSuccess={resetSuccess}
      SettingsButton={SettingsButton}
      SettingsInputContainer={SettingsInputContainer}
    />
  );
};

const mapStateToProps = (state) => ({
  roles: state.user.roles,
});

export default compose(
  connect(mapStateToProps),
)(ManageCard);